import React from "react";
import styled from "styled-components";
import borrowerMobileImg from "../../images/borrower_mobile.svg";
import clockImg from "../../images/clock.svg";
import noteImg from "../../images/note.svg";
import loanBookImg from "../../images/loan_book.svg";

const StyledWrapper = styled.section`
  background-color: #ffe9dfa6;
  margin: 0 25px 256px 29px;
  font-family: Inter;
  color: #000000;
  padding: 98px 0 106px 0;
  border-radius: 60px;
  letter-spacing: 0em;
  text-align: left;
  font-weight: 400;

  @media (max-width: 900px) {
    border-radius: 45px;
    padding: 61px 3px 81px 26px;
    margin: 0 14px 173px 16px;
  }

  @media (min-width: 1440px) {
    max-width: 1410px;
    margin: 0 auto 173px;
  }

  .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    @media (max-width: 900px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .mobile-img {
    @media (max-width: 900px) {
      width: 0px;
      height: 0px;
    }
  }

  .benefits-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 100px;
    @media (max-width: 900px) {
      margin-left: 0;
    }
  }

  .benefit-contaner {
    display: flex;
    align-items: center;
    margin-top: 66px;
    :first-child {
      margin-top: 0px;
    }
    :last-child {
      margin-top: 55px;
    }
    @media (max-width: 900px) {
      margin-top: 81px;
      :first-child {
        margin-top: 0px;
      }
      :last-child {
        margin-top: 89px;
      }
    }
  }

  .benefit-text-container {
    margin-left: 45px;
  }

  .benefit-heading {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;

    @media (max-width: 900px) {
      font-size: 22px;
      font-weight: 700;
      line-height: 28px;
    }
  }

  .benefit-text {
    font-size: 24px;
    line-height: 32px;
    margin-top: 11px;

    @media (max-width: 900px) {
      margin-top: 8px;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

const Benefits = () => {
  return (
    <StyledWrapper>
      <div className="wrapper">
        <img src={borrowerMobileImg} alt="" className="mobile-img" />

        <div className="benefits-container">
          <div className="benefit-contaner">
            <img src={clockImg} alt="" />
            <div className="benefit-text-container">
              <div className="benefit-heading">
                24 Hour <br />
                disbursal
              </div>
              <div className="benefit-text">
                Or we waive your
                <br /> processing fees
              </div>
            </div>
          </div>

          <div className="benefit-contaner">
            <img src={noteImg} alt="" />
            <div className="benefit-text-container">
              <div className="benefit-heading">
                Highest Disbursal <br />
                Rates (94%)
              </div>
              <div className="benefit-text">
                Thanks to the preselection
                <br /> process
              </div>
            </div>
          </div>

          <div className="benefit-contaner">
            <img src={loanBookImg} alt="" />
            <div className="benefit-text-container">
              <div className="benefit-heading">
                No Foreclosure <br />
                Charges
              </div>
              <div className="benefit-text">
                Pre-pay in full,
                <br /> whenever you want.
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

export default Benefits;
